var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useCase.item_type === 'image')?_c('div',{staticClass:"use-case"},[_c('cms-image',{staticClass:"use-case-image",attrs:{"src":{
				path: _vm.useCase.item.use_case_image.path,
				alt: `Use case ${_vm.productName}`,
				title: `Best spot for ${_vm.productName}`
			},"base":{width: 450, height: 328, background: 'transparent', fit: 'cover'},"lazy":""}})],1):(_vm.useCase.item_type === 'article' && _vm.article)?_c('base-article',{attrs:{"article":_vm.article}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }